import { render, staticRenderFns } from "./buTieTables.vue?vue&type=template&id=523abc40&"
import script from "./buTieTables.vue?vue&type=script&lang=js&"
export * from "./buTieTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports